import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomDatePipe } from '@app/v2/shared/pipes/date/custom-date.pipe';
import { EntitlementStatus, FeatureFlagsFacade, Resource, UserDataFacade, UserPreferences } from '@ra-state';
import {
  ITooltipConfig,
  TextButtonComponent,
  TooltipDirective,
  TooltipPosition,
} from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-ag-deallocate-btn',
  templateUrl: './ag-deallocate-btn.component.html',
  styleUrls: ['./ag-deallocate-btn.component.scss'],
  imports: [TextButtonComponent, TooltipDirective, AsyncPipe],
})
export class AgDeallocateBtnComponent implements ICellRendererAngularComp {
  private readonly userDataFacade = inject(UserDataFacade);
  private readonly featureFlagFacade = inject(FeatureFlagsFacade);

  readonly tooltipConfig: ITooltipConfig = { position: TooltipPosition.Top, maxWidth: 400 };
  ENTITLEMENT_STATUS = EntitlementStatus;
  private params: any;

  userData: UserPreferences;
  pendingEntitlementTooltip: string = '';
  customDatePipe = new CustomDatePipe();
  userData$ = this.userDataFacade.userData$.pipe(
    tap((userData) => {
      if (userData) {
        this.userData = userData;
      }
    }),
  );
  resources: Resource[];
  manageableResources$ = this.userDataFacade.manageableResources$.pipe(
    tap((resources) => {
      this.resources = resources;
    }),
  );
  preferredLanguage: string = '';
  preferredLanguage$ = this.userDataFacade.preferredLanguage$.pipe(
    tap((language) => {
      this.preferredLanguage = String(language);
      const activationDate = this.customDatePipe.transform(
        this.params.data.activationDate,
        'mediumDate',
        this.preferredLanguage,
      );

      if (this.params.data.status === this.ENTITLEMENT_STATUS.PENDING) {
        this.pendingEntitlementTooltip = `This entitlement is scheduled to become active on ${activationDate}.`;
      }
    }),
  );

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
  agInit(params: any): void {
    this.params = params;
  }

  btnClickedHandler(_event?: any): void {
    this.params.clicked(this.params.data);
  }

  get Status(): EntitlementStatus {
    return this.params?.data.status;
  }

  get showDeallocateBtn$(): Observable<boolean> {
    return this.featureFlagFacade.allowDeallocationFlag$.pipe(
      map((flagManager) =>
        flagManager.showDeallocateBtn(this.params.data.serviceKind, this.params.data.status, this.resources),
      ),
    );
  }
}
